import BaseService from './BaseService.js'

export default {
  get(id) {
    return BaseService.get(`Officer/${id}`)
  },
  getByEntity(id) {
    return BaseService.get(`Officer/Entity/${id}`)
  },
  post(officer) {
    return BaseService.post(`Officer`, officer)
  },
  put(officer) {
    return BaseService.put(`Officer`, officer)
  },
  delete(id) {
    return BaseService.delete(`Officer/${id}`)
  },
  validate(entityId) {
    return BaseService.post(`Officer/Validate`, entityId)
  },
  saveDocument(document) {
    const formData = new FormData()
    formData.append('changeID', document.changeID)
    formData.append('entityID', document.entityID)
    formData.append('file', document.file)

    return BaseService.postFormData(`Officer/Document`, formData)
  }
}
